import React from "react";
import SupportEmail from "../components/SupportEmail";

const Home = () => {
  return (
    <>
      <div className="home-container">
        <div
          className="home-tagline"
          style={{
            fontStyle: 'italic',
            fontSize: '24pt',
            color: '#fff',
            textAlign: 'center',
            marginBottom: '16px',
            letterSpacing: '0.02em'
          }}
        >
          Your Personal Spy Network.
        </div>
        <img src="/logo.png" alt="Omega Void Logo" className="logo" />
      </div>
      <SupportEmail />
    </>
  );
};

export default Home;